<template>
<div class="row justify-content-center">
  <div class="nav-scroller pt-2">
    <nav class="nav d-flex justify-content-between">

      <router-link v-for="category in categoriesWithFeeds" v-bind:key="category.id" :to="{ name: routeName, params: { category: category.id } }" class="px-2 text-muted">{{category.name}}</router-link>

    </nav>
  </div>
  </div>
</template>

<script>

export default {
  name: "Navbar.FeedCategories",
  props: {
    categories: Array,
    routeName: String,
  },
  computed: {
    categoriesWithFeeds: function() {
      return this.categories.filter( (catgegory) => catgegory.urls.length > 0 );
  }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.nav-scroller .nav-link {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
}
.active {
	border-bottom: groove medium #007bff;
}

</style>
